export default __webpack_public_path__ + "static/orange-shopping-bags-e128dfc8c772590d4227eb91292130ed.jpg";